var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg4 = function Svg4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M13.828 7.215c.038.259.053.517.053.783a6.387 6.387 0 0 1-6.379 6.382 6.387 6.387 0 0 1-6.378-6.382A6.383 6.383 0 0 1 7.502 1.62c2.049 0 3.877.97 5.041 2.48l1.072-.443A7.49 7.49 0 0 0 7.502.497C3.363.496 0 3.862 0 7.997s3.363 7.506 7.502 7.506 7.502-3.367 7.502-7.506q0-.624-.1-1.225z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M7.502 4.9c.652 0 1.262.203 1.76.551l1.173-.483a4.18 4.18 0 0 0-2.933-1.19 4.23 4.23 0 0 0-4.225 4.22 4.23 4.23 0 0 0 4.225 4.225c2.33 0 4.18-1.85 4.225-4.142l-1.176.487a3.11 3.11 0 0 1-3.049 2.531A3.105 3.105 0 0 1 4.401 8 3.1 3.1 0 0 1 7.502 4.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M17.985 3.68a.56.56 0 0 0-.52-.348.55.55 0 0 0-.214.044l-3.049 1.255-1.041.43-2.004.825-1.052.434-2.817 1.161a.563.563 0 0 0 .214 1.083.55.55 0 0 0 .213-.045l2.82-1.161 1.053-.435 2.004-.824 1.041-.43 3.045-1.255a.564.564 0 0 0 .307-.734"
  })));
};
export default Svg4;